import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-arrowdownright",
  "use": "icon-th-arrowdownright-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-arrowdownright\">\n<path d=\"M25 11V24C25 24.2652 24.8946 24.5196 24.7071 24.7071C24.5196 24.8947 24.2652 25 24 25H11C10.7348 25 10.4804 24.8947 10.2929 24.7071C10.1054 24.5196 10 24.2652 10 24C10 23.7348 10.1054 23.4804 10.2929 23.2929C10.4804 23.1054 10.7348 23 11 23H21.5862L7.2925 8.70751C7.10486 8.51987 6.99944 8.26537 6.99944 8.00001C6.99944 7.73464 7.10486 7.48015 7.2925 7.29251C7.48014 7.10487 7.73464 6.99945 8 6.99945C8.26536 6.99945 8.51986 7.10487 8.7075 7.29251L23 21.5863V11C23 10.7348 23.1054 10.4804 23.2929 10.2929C23.4804 10.1054 23.7348 10 24 10C24.2652 10 24.5196 10.1054 24.7071 10.2929C24.8946 10.4804 25 10.7348 25 11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-arrowdownright.svg
// module id = kT++
// module chunks = 83